import useConfig from 'src/config/hooks/useConfig'
import { Abi } from 'thirdweb/utils'
import { DotcAbi } from '../../abis'
import useContract from '../common/useContract/useContract'

const useDotcContract = () => {
  const config = useConfig()
  const { contract } = useContract(
    config.contractsAddresses.dotcContractAddress,
    DotcAbi as Abi
  )

  return contract
}

export default useDotcContract
